/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stellar_system/white_dwarf': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 18.499c-4.687 0-8.5-3.813-8.5-8.5s3.813-8.5 8.5-8.5 8.5 3.813 8.5 8.5-3.813 8.5-8.5 8.5zm0-16c-4.136 0-7.5 3.364-7.5 7.5s3.364 7.5 7.5 7.5 7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5z"/><path pid="1" d="M12.35 2.313L13.807.752l-.071 2.136zm-6.123.59L6.154.769l1.459 1.56zM2.314 7.65L.752 6.191l2.137.074zm.59 6.122l-2.134.074 1.562-1.459zm4.746 3.915l-1.459 1.561.075-2.136zm6.123-.59l.073 2.135-1.457-1.561zm3.915-4.747l1.56 1.459-2.135-.074zm-.59-6.123l2.134-.075-1.56 1.46z"/><circle pid="2" cx="10" cy="9.999" r="1.5"/>'
  }
})
